export function setCityList(state, value) {
    state.cityList = value;
    state.cityList.forEach((el) => {el.search = `${el.region} ${el.name}`.toLocaleLowerCase()});
}

export function setMainMenu(state, value) {
    state.mainMenu = value;
}
